import React, { useCallback, useState, useEffect } from "react";
import { Form, Image, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import { Role, Site } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { isAdmin, isMaster } from "../../../../utils/checkPermission";
import { initialValues, validationSchema } from "./SiteForm.form";
import { useNavigate } from "react-router-dom";
import "./SiteForm.scss";
import { useLanguage } from "../../../../contexts";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const siteController = new Site();
const roleController = new Role();

export function SiteForm(props) {
  const { close, onReload, site, company } = props;
  const {
    accessToken,
    user: { role },
  } = useAuth();
  const [listRoles, setListRoles] = useState([]);

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  useEffect(() => {
    roleController.getRoles(accessToken, true).then((response) => {
      setListRoles(response);
    });
  }, []);

  const formik = useFormik({
    initialValues: initialValues(site),
    validationSchema: validationSchema(site),
    validateOnChange: false,
    onSubmit: async (formValue, { setSubmitting }) => {
      try {
        if (!site) {
          formValue.company = company;
          // console.log(company)
          const response = await siteController.createSite(
            accessToken,
            formValue
          );
          if (response.code === 200) {
            toast.success("Formulario enviado correctamente!");
          } else {
            toast.error(` ${response.msg}`);
          }
        } else {
          const response2 = await siteController.updateSite(
            accessToken,
            site._id,
            formValue
          );

          if (response2.code === 200) {
            toast.success("Formulario actualizado correctamente!");
          } else {
            toast.error(`${response2.msg}`);
          }
        }
        // Retrasar el cierre del modal o el reload para dar tiempo a que la tostada se vea
        setTimeout(() => {
          // Cerrar el modal
          close();
          // O recargar la página
          onReload();
        }, 1000);
      } catch (error) {
        toast.error(
          `${
            error.msg ? error.msg : "Error en el servidor intente nuevamente"
          }`
        );
      } finally {
        setSubmitting(false); // Se asegura de que Formik termine su proceso de envío
      }
    },
  });

  function formatCuit(cuit) {
    // Eliminar cualquier carácter que no sea un número
    cuit = cuit.replace(/\D/g, "");

    // Aplica el formato de CUIT: XX-XXXXXXXX-X
    if (cuit.length <= 2) {
      return cuit; // Si hay menos de 2 caracteres, no formatear
    }
    if (cuit.length <= 10) {
      return cuit.slice(0, 2) + "-" + cuit.slice(2); // Si hay hasta 10 caracteres, formatear sin guion final
    }
    return (
      cuit.slice(0, 2) + "-" + cuit.slice(2, 10) + "-" + cuit.slice(10, 11)
    ); // Formato completo
  }

  return (
    <Form className="site-form" onSubmit={formik.handleSubmit}>
      <Form.Group widths="equal">
        <Form.Input
          label={<label><span style={{ color: "red", marginRight: 4 }}>*</span>{t("name")}</label>}
          name="name"
          onChange={formik.handleChange}
          value={formik.values.name}
          error={formik.errors.name}
        />
        <Form.Input
          label={<label><span style={{ color: "red", marginRight: 4 }}>*</span>{t("cuit")}</label>}
          name="cuit"
          onChange={formik.handleChange}
          value={formik.values.cuit ? formatCuit(formik.values.cuit) : ""}
          error={formik.errors.cuit}
          maxLenght={13}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Input
          label={<label><span style={{ color: "red", marginRight: 4 }}>*</span>{t("phone")}</label>}
          name="phone"
          onChange={formik.handleChange}
          value={formik.values.phone}
          error={formik.errors.phone}
        />
        <Form.Input
          label={<label><span style={{ color: "red", marginRight: 4 }}>*</span>{t("address")}</label>}
          name="address"
          onChange={formik.handleChange}
          value={formik.values.address}
          error={formik.errors.address}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Input
          label={<label><span style={{ color: "red", marginRight: 4 }}>*</span>{t("email")}</label>}
          name="email"
          onChange={formik.handleChange}
          value={formik.values.email}
          error={formik.errors.email}
        />
      </Form.Group>

      <div className="site-form__actions">
        <Button
          type="submit"
          primary
          loading={formik.isSubmitting}
        >
          {!site ? t("save") : t("update")}
        </Button>
        <Button
          type="button"
          secondary
          onClick={close}
        >
          {t("cancel")}
        </Button>
      </div>

      {/* Este es el contenedor que maneja las tostadas */}
      <ToastContainer
        position="top-center"
        autoClose={800}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Form>
  );
}
